export const isActivePath = (path?: string): boolean => !!path && window.location.pathname.includes(path)
